import React, { useEffect, useState } from "react";
import { useParams, Routes, Route, NavLink, Navigate } from "react-router-dom";

import Loader from "../../../components/loader";
import api from "../../../services/api";
import Info from "./info";
import Edit from "./edit";
import toast from "react-hot-toast";

const tabItems = [
  { href: "/info", title: "Info" },
  { href: "/edit", title: "Edit" },
  { href: "/logs", title: "Logs" },
  { href: "/raw", title: "Raw" },
];

export default function Index() {
  const { id } = useParams();
  const [device, setDevice] = useState();

  const getDevice = async () => {
    try {
      const { data, ok } = await api.get(`/device/${id}`);
      if (!ok) return toast.error(data.error);
      setDevice(data);
    } catch (e) {
      toast.error("Error getting device");
    }
  };

  useEffect(() => {
    getDevice();
  }, [id]);

  if (!device) return <Loader />;

  return (
    <div className="w-full max-w-none mx-auto mt-5 px-4">
      <div className="mb-2 flex items-center justify-between gap-2">
        <nav className="flex-1 bg-white rounded-md flex item-center gap-1 border border-neutral-300 p-1">
          {tabItems.map(({ href, title }) => (
            <NavLink
              key={href}
              to={`/device/${id}${href}`}
              className={({ isActive }) => (isActive ? "blue-btn" : "transparent-btn cursor-pointer relative rounded flex items-center")}
            >
              <div className="flex items-center gap-2 truncate">{title}</div>
            </NavLink>
          ))}
        </nav>
      </div>
      
      <div>
        <Routes>
          <Route path="/" element={<Navigate to="info" replace />} />
          <Route path="/info" element={<Info device={device} />} />
          <Route path="/edit" element={<Edit device={device} onSave={(data) => setDevice(data)} />} />
          <Route path="/logs" element={<Logs device={device} />} />
          <Route path="/raw" element={<Raw device={device} />} />
        </Routes>
      </div>
    </div>
  );
}

const Logs = ({ device }) => {
  return (
    <div>
      {device.logs
        .sort((a, b) => (a.created_at > b.created_at ? -1 : 1))
        .map((log) => {
          return <Card key={log._id} log={log} />;
        })}
    </div>
  );
};

const Card = ({ log }) => {
  return (
    <div className="bg-white shadow overflow-hidden md:rounded-lg mb-2 p-2">
      <span className="font-bold">
        Updated at {new Date(log.created_at).toLocaleString()} by {log.user_name}
      </span>
      <div>{log.text}</div>
    </div>
  );
};

const Raw = ({ device }) => {
  return (
    <div className="overflow-x-auto">
      <pre className="bg-gray-800 text-white p-4 rounded-md whitespace-pre overflow-x-auto">{JSON.stringify(device, null, 2)}</pre>
    </div>
  );
};